module.exports = __webpack_public_path__ + "static/Stacy-Fiehler.jpeg";